import theme from "../constants/theme"

// Required for exporting primary (base) theme styles
// and extend to secondary theme for re-theming.
export default theme
